import React, { memo } from 'react';

import Icon from '../components/Icon';
import Button from '../components/Button';
import GameLink from '../components/GameLink';

export default memo(({ source: sourceProp, code, childCode, apps }) => {
  return (
    <nav>
      {apps.map(app => {
        let source = `${sourceProp}||${code}||${childCode}`;
        let id = app.softID || '';
        if (app.androidType === '1') {
          id = app.packageName;
        }

        return (
          <GameLink
            key={id}
            info={{
              targetType: '1',
              appInfo: app,
            }}
            source={source}
            logInfo={{
              category: 'C',
              action: 'Game_Non_Button',
              params: {
                id,
                type: 'soft',
                source,
              },
              bizInfo: app.bizInfo,
            }}
          >
            <Icon className="icon" app={app} />
            <section>
              <h1 title={app.softName}>{app.softName}</h1>
              <p>{app.downloadCount || '1万次'}安装</p>
              <Button
                soft={app}
                className="btn"
                logInfo={{source}} />
            </section>
          </GameLink>
        );
      })}
    </nav>
  );
});
